/*
 * File: /src/router/routes/settings.js
 * Created Date: Friday November 26th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 26th November 2021 9:58:06 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

const UserSettings = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/UserSettings.vue'
  );

const CompanySettings = () =>
  import(
    /* webpackChunkName: "Settings" */ 'src/components/Dashboard/Views/Settings/CompanySettings.vue'
  );

const LostReasons = () =>
  import(
    /* webpackChunkName: "LostReasons" */ 'src/components/Dashboard/Views/Settings/LostReasonList.vue'
  );


export const settingsRoutes = [
  {
    path: 'settings/users',
    name: 'User Settings',
    component: UserSettings
  },
  {
    path: 'settings/company',
    name: 'Global Settings',
    component: CompanySettings
  },

  {
    path: 'settings/lost-reasons',
    name: 'Lost Reasons',
    component: LostReasons,
  }
];
